import { useState } from "react";
// models
import {
  PostulacionModel,
  initialValuesPostulacionModel,
} from "../models/PostulacionesModel/postulacion.model";
// api services
import apiParticipantes from "../api/Participantes/api-participantes";
import apiMaestras from "../api/Maestras/api-maestras";

export const useAsignarJurados = () => {
  const [allpostulacionessinfiltro, SetAllPostulacionesSinFiltro] = useState<any>([]);
  const [datosFiltro, setDatosFiltro] = useState<any[]>([]);
  const [preFiltro, setPreFiltro] = useState<any[]>([]);
  const [allpostulaciones, setAllPostulaciones] = useState<any>([]);
  const [modal, ] = useState<boolean>(false);
  const [postulacion, ] = useState<PostulacionModel>(initialValuesPostulacionModel);
  const [postulacionesSeleccionadas, setPostulacionesSeleccionadas] = useState<any>([]);
  const [totalregistros, setTotalRegistros] = useState<number>(0);
  const [cantidadpáginas, setCantidadPáginas] = useState<number>(10);
  const [categorias, setCategorias] = useState<any>([]);
  const [filasseleccionadas, setFilasSeleccionadas] = useState<any>([]);
  const [modalasignarjurados, setModalAsignarJurados] = useState(false);
  const [lineasconvocatoria, setLineasConvocatorias] = useState<any>([]);
  const [filtros, setFiltros] = useState<any>({
    buscarpalabra: "",
    linea_convocatoria: null,
    categoria: null,
    estado: "",
  });
  const cargarTodasPostulaciones = async () => {
    let { data: postulaciones } = await apiParticipantes.consultarPostulacionesEnPorcesoArtistas();

    let postulacionesMap = postulaciones.map((x: any, idx: any) => {
      return {
        ...x,
        index: idx + 1
      }
    })

    let postulacionesfiltro = postulacionesMap.filter((x: any) => x.tipo === 1);

    postulacionesfiltro = postulacionesMap.filter((x: any) => x.links !== null && (x.estado === "Aceptado" ||  x.estado === "Por evaluar"));

    let data = await apiMaestras.obtenerLineaConvocatoria();

    // console.log(data)
    // let dataMap = data.sort(function (a: any, b: any) {
    //   if (a.id > b.id) {
    //     return 1;
    //   }
    //   if (a.id < b.id) {
    //     return -1;
    //   }
    //   // a must be equal to b
    //   return 0;
    // });
    // let lineaConvocatorias = dataMap;
    // console.log(data)
    setLineasConvocatorias(data);

    setTotalRegistros(postulacionesfiltro.length);



    // postulacionesAceptadas = postulacionesAceptadas.map((data: any) => {

    //   let lineaConvocatoria = lineaConvocatorias.find((x: any) => x.id == data.linea_convocatoria)
    //   return {
    //     ...data,
    //     linea_convocatoria: lineaConvocatoria.nombre,
    //     linea_convocatoriaId: data.linea_convocatoria,
    //     checked: false,
    //   };
    // });
    
    setDatosFiltro(postulacionesfiltro);
    setPreFiltro(postulacionesfiltro);
    SetAllPostulacionesSinFiltro(postulacionesfiltro);

    return setAllPostulaciones(postulacionesfiltro);
  };
  const cambiarCantidadPaginas = (e: any, value: any) => {
    setCantidadPáginas(value);
  };

  const obtenerCategoriasLineas = async (id_linea: number) => {
    let data = await apiMaestras.obtenerCategoriasPorLinea(id_linea);
    //console.log(data)
    return setCategorias(data.data);
  };


  const cambiarCheckbox = (datos: any) => {
    let infoupdate = datosFiltro.map((data: any) => {
      if (data.id_postulacion === datos.id_postulacion) {
        return {
          ...data,
          checked: !data.checked,
        };
      }
      return {
        ...data,
      };
    });

    let postulacionesSeleccionadas = infoupdate.filter(x => x.checked);
    let idsProyectos = postulacionesSeleccionadas.map((x: any) => {
      return {
        id_postulacion: x.id_postulacion
      }
    })

    localStorage.setItem("proyectosAsignados", JSON.stringify(idsProyectos))
    // dispatch(asignarProyectos(idsProyectos));
    setPostulacionesSeleccionadas(postulacionesSeleccionadas)

    return setDatosFiltro(infoupdate);
  };

  const toggleSeleccionarTodos = () => {
    const allSelected = datosFiltro.every((data: any) => data.checked);

    let infoupdate = datosFiltro.map((data: any) => ({
      ...data,
      checked: !allSelected, // Cambiar todos al estado opuesto
    }));

    let postulacionesSeleccionadas = infoupdate.filter(x => x.checked);
    let idsProyectos = postulacionesSeleccionadas.map((x: any) => ({
      id_postulacion: x.id_postulacion
    }));

    localStorage.setItem("proyectosAsignados", JSON.stringify(idsProyectos));
    setPostulacionesSeleccionadas(postulacionesSeleccionadas);
    setDatosFiltro(infoupdate);
  };

  const cambiarFilasSeleccionadas = (filaseleccionada: any) => {
    return setFilasSeleccionadas({ filaseleccionada });
  };
  const limpiarFiltros = () => {
    setDatosFiltro(allpostulacionessinfiltro);
    setFiltros({
      buscarpalabra: "",
      linea_convocatoria: null,
      categoria: null,
      estado: null,
    })
    // return setFiltros(initialFiltrosPostulacionModel);
  };


  const handleLineaChange = async (id_linea: number) => {
    try {
      let { data } = await apiMaestras.obtenerCategoriasPorLinea(id_linea);
      setCategorias(data);

      setFiltros({
        ...filtros,
        linea_convocatoria: id_linea
      })
    } catch (error) {
      console.log(error)
    }
  }

  const buscarpostulaciones = () => {
    let filtro = preFiltro;
    if (filtros.buscarpalabra !== '') {
      filtro = filtro.filter((x: any) => {
        if (x.nombre_propuesta !== null) {
          if (x.nombre_propuesta.toUpperCase().indexOf(filtros.buscarpalabra.trim().toUpperCase()) > -1) {
            return x;
          }
           //Filtro por código (radicado)
           if (x.radicado.toUpperCase().includes(filtros.buscarpalabra.trim().toUpperCase())) {
            return x;
          }
        }
      })
    }

    if (filtros.linea_convocatoria !== null) {
      filtro = filtro.filter((x: any) => {
        if (x.linea_convocatoria_id === filtros.linea_convocatoria) {
          return x;
        }
      })
    }

    if (filtros.categoria && filtros.categoria !== "") {
      filtro = filtro.filter((x: any) => {
        if (x.categoria_linea_convocatoria !== null && x.categoria_linea_convocatoria !== '') {
          if (x.categoria_linea_convocatoria === filtros.categoria) {
            return x;
          }
        }
      });
    }

    if (filtros.estado) {

      if (filtros.estado === "null") {
        filtro = filtro.filter((x: any) => {
          if (x.estado_jurado === null) {
            return x;
          }
        })
      }

      if (filtros.estado !== "null") {
        filtro = filtro.filter((x: any) => {
          if (x.estado_jurado === filtros.estado) {
            return x;
          }
        })
      }
    }
    //console.log(filtro, 'antes de enviar')
    setTotalRegistros(filtro.length)
    return setDatosFiltro(filtro)
  };
  const agregarPostulacionSeleccionada = (postulacion: any) => {
    let infoupdate: Array<PostulacionModel> = [];
    if (postulacionesSeleccionadas.length !== 0) {
      infoupdate = [...postulacionesSeleccionadas, postulacion];
    } else {
      infoupdate = [postulacion];
    }
    cambiarCheckbox(postulacion.id_postulacion);
    // dispatch(guardarJuradosCriterios(infoupdate))
    return setPostulacionesSeleccionadas(infoupdate);
  };
  return {
    allpostulaciones,
    setAllPostulaciones,
    cargarTodasPostulaciones,
    modal,
    postulacion,
    totalregistros,
    cantidadpáginas,
    cambiarCantidadPaginas,
    categorias,
    obtenerCategoriasLineas,
    cambiarCheckbox,
    filasseleccionadas,
    cambiarFilasSeleccionadas,
    setFilasSeleccionadas,
    modalasignarjurados,
    setModalAsignarJurados,
    lineasconvocatoria,
    filtros,
    setFiltros,
    limpiarFiltros,
    buscarpostulaciones,
    postulacionesSeleccionadas,
    setPostulacionesSeleccionadas,
    agregarPostulacionSeleccionada,
    handleLineaChange,
    datosFiltro,
    toggleSeleccionarTodos
  };
};
